/*
 show/Hide, при нажатию на стрелку админ панели показывает/скрывает кнопки админ панели. Устанавливает/снимает флаг режима редактирования в куки
 Функция вызывается на событие клика по кнопке и параметра button f="shHd" смотрите view/header.php, подписываемся на события тут src/js/bundle.js
*/

//import { act } from '../../act';

JED.shHd = (el) => {//
    //document.body.style.transition = 'padding-top 0.5s, background-color 0.9s';
    console.log('shHd.js is run');
    if (JED.tune.edit == 1) {
        JED.tune.edit = 0;
        //csMode.classList.remove('edit');
    } else {
        JED.tune.edit = 1;
        //csMode.classList.add('edit');
        //showBtn();// Релоад же не позволит
    }
    //setMode();
    setCookie('tune', JED.tune);
    location.reload();
}